import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'cliente');

const clienteActions = {
  ...genericActions(basePath),
  buscar: { method: 'GET', url: `${basePath}/{id}` },
  buscarLojas: { method: 'GET', url: `${basePath}/{id}/lojas` },
  ativarMassa: { method: 'PUT', url: `${basePath}/ativacao-massa` },
  listarFiltrado: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}` },
  obter: { method: 'GET', url: `${basePath}/{codigo}` },
  listarAutocomplete: { method: 'GET', url: `${basePath}/autocompletar?tamanhoPagina=6&numeroPagina=1&indAtivo=true` },
  listarAtivosConsiderandoUsuario:
  { method: 'GET', url: `${basePath}/considerando-usuario?nome={nome}&indAtivo=true&colunaOrdenacao=nom_cliente` },
};

export default resource => resource(`${basePath}`, {}, clienteActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/cliente.js